import { createSortOption } from "@nosto/preact"
export const sizes = [34, 36, 78]

export const sortOptions = [
    createSortOption("-date published", "New Arrivals", { field: "datePublished", order: "desc" }),
    createSortOption("stats.revenue", "Best Sellers", { field: "stats.revenue", order: "desc" }),
    createSortOption("name", "Alphabetically, A-Z", { field: "name", order: "asc" }),
    createSortOption("-name", "Alphabetically, Z-A", { field: "name", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[1],
    categorySize: sizes[2],
    autocompleteProductsSize: 2,
    autocompleteKeywordsSize: 3,
    historySize: 3
}
